<template>
  <div
    v-if="!cookieDisabled && (exceeds || equals || aboveEighty)"
    class="quota-exceed-alert"
    :class="{
      'error': exceeds,
      'warn': !exceeds && (equals || aboveEighty),
    }"
  >
    <CIcon name="cilWarning" height="16" width="16" />
    <span class="message">{{ message }}</span>
    <div class="actions">
      <CButton
        variant="ghost"
        color="dark"
        @click="dismissAlert()"
        :title="$t('widget.DismissTrafficOverrunAlertTooltip')"
      >
        {{$t('widget.Dismiss')}}
      </CButton>
      <CButton
        v-if="isNotTrustyCDN"
        :color="exceeds ? 'danger' : 'warning'"
        @click="openDomainConfiguration"
        class="text-white"
      >
        {{$t('Upgrade')}}
      </CButton>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

const cookieName = 'TRAFFIC_OVERRUN_ALERT';

export default {
  name: 'TrafficOverrunAlert',
  props: {
    exceeds: {
      type: Boolean,
      default: false
    },
    equals: {
      type: Boolean,
      default: false
    },
    aboveEighty: {
      type: Boolean,
      default: false
    },
  },
  emits: ['open-configure-domain'],
  data: () => ({
    cookieDisabled: false,
  }),
  created() {
    this.cookieDisabled = this.getCookieValue() === 'false';
  },
  computed: {
    ...mapGetters(["isNotTrustyCDN"]),
    message() {
      if (this.exceeds) {
        return this.$t('widget.OverrunTrafficExceedAlert');
      } else if (this.equals) {
        return this.$t('widget.OverrunTrafficEqualsAlert');
      } else if (this.aboveEighty) {
        return this.$t('widget.OverrunTrafficExceedEightyPercentAlert');
      } else {
        return '';
      }
    },
  },
  methods: {
    openDomainConfiguration() {
      this.$emit('open:dialog')
    },
    getCookieValue() {
      const name = `${cookieName}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
      for (const element of cookieArray) {
        let cookie = element.trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return '';
    },
    dismissAlert() {
      let date = new Date();
      date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day
      document.cookie = `${cookieName}=false; expires=${date.toUTCString()}; path=/`;
      
      this.cookieDisabled = true;
    }
  }
}
</script>

<style lang="scss">
.quota-exceed-alert {
  display: flex;
  align-items: center;
  gap: .875rem;
  margin-bottom: 1rem;
  padding-block: 8px;
  padding-inline: 1rem 10px;
  border-radius: 4px;

  &.error {
    background-color: rgba(255, 0, 0, 0.15);
    color: rgba(255, 0, 0, 1);
    border: 1px solid rgba(255, 0, 0, 0.4);
  }
  &.warn {
    background-color: rgba(255, 165, 0, 0.15);
    color: rgba(255, 165, 0, 1);
    border: 1px solid rgba(255, 165, 0, 0.4);
  }

  .message {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  button {
    margin: 0;
  }
  
  .actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
}
</style>